<template>
  <div
    v-if="showComponent"
    :class="['nav-list-element column small-12', columnsClass]"
    data-test-navigation-list-element-root
  >
    <a
      :href="element.navigationListBaseModel.link.url"
      class="row"
      @click="dispatchClickTrackingEvent(element.navigationListBaseModel.title)"
    >
      <!-- Icon Element -->
      <div class="column small-3 medium-12" aria-hidden="true">
        <div class="icon-container">
          <span class="icon icon-large" :class="'icon-' + element.icon.iconValue">
            <!-- Thumbnail Logo - medium and up -->
            <div
              v-if="showThumbnail"
              class="thumbnail-container hide-for-small-only"
              data-test-navigation-list-thumbnail
            >
              <img
                class="column thumbnail-image"
                :src="element.navigationListBaseModel.thumbnailImage.url"
                alt=""
              />
            </div>
          </span>
        </div>
      </div>

      <!-- Title & Body -->
      <div class="column small-9 medium-12">
        <p v-if="element.navigationListBaseModel.title !== ''" class="list-element-title">
          <span v-html="element.navigationListBaseModel.title" />
          <span class="list-nav-arrow">&gt;</span>
        </p>
        <p v-if="showBody" class="list-element-body" v-html="element.body" />
      </div>

      <!-- Thumbnail Logo - small screen -->
      <div
        v-if="showThumbnail"
        class="thumbnail-container show-for-small-only"
        data-test-navigation-list-thumbnail
      >
        <img
          class="column thumbnail-image"
          :src="element.navigationListBaseModel.thumbnailImage.url"
        />
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import Utility from '@/common/UtilityFunctions.js';
import NavigationListIconElement from '../interfaces/NavigationListIconElement';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'NavigationListIconElement',
  props: {
    element: {
      type: Object as PropType<NavigationListIconElement>,
      default() {
        return {
          navigationListBaseModel: {
            title: null,
            thumbnailImage: null,
            link: null
          },
          icon: null,
          body: null,
          elementTypeEnum: 1
        } as NavigationListIconElement;
      }
    },
    description: {
      type: String,
      default() {
        return '';
      }
    },
    columnsClass: {
      type: String,
      default() {
        return 'medium-4 large-2';
      }
    }
  },
  computed: {
    showComponent(): boolean {
      return (
        this.element.navigationListBaseModel !== null &&
        this.element.navigationListBaseModel.link !== null
      );
    },
    showBody(): boolean {
      return this.element.body !== '' && this.element.body !== '&nbsp;';
    },
    showThumbnail(): boolean {
      return (
        this.element.navigationListBaseModel !== null &&
        this.element.navigationListBaseModel.thumbnailImage !== null &&
        this.element.navigationListBaseModel.thumbnailImage.url !== ''
      );
    }
  },
  methods: {
    dispatchClickTrackingEvent(title: string) {
      this.$store.dispatch('Events/register', {
        event: 'navigation-list-click-element',
        id: 'navigationList',
        vm: {
          description: Utility.decodeHtml(this.description),
          label: title
        }
      });
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
@import 'src/styles/colors.scss';

.nav-list-element {
  margin-bottom: rem-calc(30);
  text-align: center;

  @media #{$small-only} {
    padding: rem-calc(10) rem-calc(10);
    text-align: left;
    border: 1.5px solid $disturber-color;
    border-radius: rem-calc(15);

    .thumbnail-container {
      bottom: rem-calc(-10);
      right: rem-calc(27);
      width: rem-calc(86);
      height: rem-calc(86);

      .thumbnail-image {
        position: absolute;
        right: 0;
        bottom: rem-calc(43);
        transform: translateY(50%);
        max-width: rem-calc(57);
        width: auto;
      }
    }
  }

  @media #{$medium-up} {
    &:hover {
      transform: scale(1.05);
      transition: transform 250ms;
    }

    .thumbnail-container {
      transform: translateX(25%);
    }
  }
}

a {
  text-decoration: none;
  padding: 0 rem-calc(11);
  position: relative;

  &:hover {
    span,
    p {
      color: $primary-color;
    }
  }

  .icon {
    position: relative;
  }

  .thumbnail-container {
    position: absolute;
    bottom: rem-calc(-6);
    right: rem-calc(-30);

    .thumbnail-image {
      width: 48px;
      padding: 0 rem-calc(2px);
    }
  }

  .list-element-title {
    font-size: rem-calc(26);
    line-height: rem-calc(38);
    margin-top: rem-calc(10);

    .list-nav-arrow {
      margin-left: rem-calc(5);
    }
  }

  .list-element-body {
    color: $disturber-color;
  }
}

span {
  color: $disturber-color;
  &.icon {
    color: $disturber-color;
  }
}
</style>
